import { render, staticRenderFns } from "./EditViewsForm.vue?vue&type=template&id=c4e21d8e"
import script from "./EditViewsForm.vue?vue&type=script&lang=js"
export * from "./EditViewsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports